import React from 'react'
import ScreenCyclesTable from '../../../../components/ScreenCyclesTable/ScreenCyclesTable';
import CycleStatus from '../../../../enums/cycle-status.enum';
import Modal from '../../../../components/Modal/Modal';
import { useDeletedCycleContract } from './hooks/useDeletedCycleContract';
import { DeletedCycleContractProps } from './interfaces/DeletedCycleContractItemProps';
import { useTranslation } from 'react-i18next';

const DeletedCycleContractItem: React.FC<DeletedCycleContractProps> = ({ cycles, contractName }) => {
  const {
    cycleActions,

    cycleIdRestore,
    closeSelectedCycleRestore,
    onAcceptSelectedCycleRestore,
  } = useDeletedCycleContract();
  const { t } = useTranslation();

  const contractTitle = `${t('labels.contractName')}: ${contractName}`;

  return (
    <>
      <li className="c-deleted-cycle-contract-item flex flex-col relative overflow-hidden rounded-lg border border-foggy-mist bg-white p-2 shadow-15 dark:border-strokedark dark:bg-boxdark">
        <span className="c-deleted-cycle-contract-item__contract-name text-base font-bold max-md:pb-1 md:text-xl">{contractTitle}</span>
        {!!cycles.length && (
          <ScreenCyclesTable
            // The InActive column set (name + actions only) never shows
            // the cycle-settings column, so this never actually fires.
            openSettings={() => undefined}
            screenCycles={cycles}
            actionsButtons={cycleActions}
            status={CycleStatus.InActive}
            pinnedActionsColumnLabel="Restore Cycle"
          />
        )}
      </li>
      <Modal
        modalTitle="Cycle Restoration"
        isVisible={!!cycleIdRestore}
        content="Are you sure you want to restore this cycle? It will go back to its original Active/Inactive/Completed tab."
        acceptBtnText={t('commonText.restore')}
        onClose={closeSelectedCycleRestore}
        onAccept={onAcceptSelectedCycleRestore}
        showAcceptBtn
        showCancelBtn
      />
    </>
  )
};

export default DeletedCycleContractItem;
